module.exports = __webpack_public_path__ + "static/media/getongoogle.feec2e37.png";